import { render, staticRenderFns } from "./PageHeaderNewRecord.vue?vue&type=template&id=ce30f0c6&scoped=true&"
import script from "./PageHeaderNewRecord.vue?vue&type=script&lang=js&"
export * from "./PageHeaderNewRecord.vue?vue&type=script&lang=js&"
import style0 from "./PageHeaderNewRecord.vue?vue&type=style&index=0&id=ce30f0c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce30f0c6",
  null
  
)

export default component.exports